module.exports = __webpack_public_path__ + "img/Poor Solder.8575d539.png";